(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/map', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/map'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.map, global.convert);
    global.map = mod.exports;
  }
})(this, function (exports, _map2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.map = undefined;

  var _map3 = _interopRequireDefault(_map2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Replaces by an array of values by running each element in the former collection thru iteratee.
   * The iteratee is invoked with three arguments: (value, index|key, collection).
   * @function
   * @memberof collection
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {function} [iteratee={@link https://lodash.com/docs#identity|lodash.identity}] The function invoked per iteration.
   * @return {Object} Returns the updated object.
   * @see {@link https://lodash.com/docs#map|lodash.map} for more information.
   * @example map({ nested: { prop: [1, 2, 3] } }, 'nested.prop', v => v * 2) // => { nested: { prop: [2, 4, 6] } }
   * @since 0.1.8
   */
  var map = (0, _convert.convert)(_map3.default);
  exports.map = map;
  exports.default = map;
});